import * as actionType from './type';

const INITIAL_STATE = {
    statusType: [],
    isLoading: false,
    error: "",
    filterdOptionlist: [],
    lead: [],
    leadScorePredictionData : {},
    pagedLead: {
        content: [],
        totalElements: 0,
        totalPages: 0,
        number: 0,
        size: 50
    }
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.REQUEST_GET_ALL_STATUS: {
            return {
                ...state,
                isLoading: true
            }
        }
        case actionType.RECEIVED_LEAD_SUCCESS_PREDICTION_DATA:{
            return {
                ...state,
                leadScorePredictionData : action?.payload
            }
        }
        case actionType.RECEIVED_ALL_LEADS: {
            return {
                ...state,
                lead: action.payload
            }
        }

        case actionType.REQUEST_GET_PAGED_LEADS: {
            return {
                ...state,
                isLoading: true
            }
        }

        case actionType.RECEIVED_PAGED_LEADS: {
            return {
                ...state,
                isLoading: false,
                pagedLead: action.payload
            }
        }

        case actionType.RECEIVED_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: "Please try again"
            }
        }

        case actionType.SET_FILTERD_OPTIONLIST: {
            return {
                ...state,
                filterdOptionlist: action.payload
            }
        }

        case actionType.RECEIVED_GET_ALL_STATUS: {
            return {
                ...state,
                isLoading: false,
                statusType: action.payload
            }
        }

        default: 
            return state;
    }
}